var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    viewBox: "0 0 100 125",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "m83.1 25.3c-3.8 0-6.9 3.1-6.9 6.9 0 3 2 5.6 4.7 6.5l-11.9 12.2-0.3 0.3c-0.1 0-0.2 0.1-0.2 0.1s-0.1 0.1-0.2 0.1-0.2 0.1-0.3 0.1h-0.2c-0.2 0-0.3 0.1-0.5 0.1s-0.4 0-0.6-0.1h-0.1c-0.2-0.1-0.3-0.1-0.5-0.2h-0.1c-0.2-0.1-0.3-0.2-0.4-0.4l-0.1-0.1c-0.1-0.1-0.2-0.3-0.3-0.4v-0.1l-0.3-0.5-12.7-21.8c2.7-0.9 4.7-3.5 4.7-6.5 0-3.8-3.1-6.9-6.9-6.9s-6.9 3.1-6.9 6.9c0 3 2 5.6 4.7 6.5l-13 22.5v0.1c-0.1 0.1-0.2 0.3-0.3 0.4 0 0 0 0.1-0.1 0.1-0.1 0.1-0.3 0.2-0.4 0.4 0 0-0.1 0-0.1 0.1-0.1 0.1-0.3 0.1-0.4 0.2h-0.2c-0.2 0-0.4 0.1-0.6 0.1s-0.3 0-0.5-0.1h-0.2c-0.1 0-0.2-0.1-0.3-0.1 0 0-0.1-0.1-0.2-0.1-0.1-0.1-0.2-0.1-0.2-0.2 0 0-0.1-0.1-0.2-0.1l-0.3-0.3-3.4-3.5-8.4-8.7c2.7-0.9 4.7-3.5 4.7-6.5 0-3.8-3.1-6.9-6.9-6.9s-6.9 3.1-6.9 6.9c0 3.4 2.4 6.2 5.7 6.8l3.2 34.4h62.2l3.3-34.5c3.2-0.6 5.7-3.4 5.7-6.8 0-3.8-3.1-6.9-6.9-6.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 19.2,
    y: 77.8,
    width: 61.5,
    height: 7.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.441efdee591e03b011d2523e585c770e.svg";
export { ForwardRef as ReactComponent };